// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import React from 'react'
import { getSsoUrl } from '../utils/envUtils'

const persistantLocalStorageKey = ['isTableAdvancedModeActivated']

const useLogout = () => {
    const [loading, setLoading] = React.useState(false)

    const logout = React.useCallback(async () => {
        setLoading(true)
        try {
            await ToktokdocLib.Auth.LogOut()
        } catch (err) {
            console.log('[IDS][useLogout]', err)
        }

        // Some values need to be kept 
        const localStorageValue = persistantLocalStorageKey.map(e => ({item : e, value : localStorage.getItem(e)}))
        localStorage.clear()
        localStorageValue.forEach(e => localStorage.setItem(e.item, e.value ?? ''))

        setLoading(false)
        window.location.href = getSsoUrl()
    }, [])

    return {
        logout,
        loading,
    }
}

export default useLogout
